rdefine('app/formular/models/BuilderModel',['backbone'],function(Backbone){
    return Backbone.Ribs.Model.extend({
        defaults:{
            name:'',
            description:'',
            finish_message:''
        }
    });
});